<template>
  <div class='carModel-model' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='100px' :inline='true' class='demo-form-inline flex1'>
        <!--        <el-form-item label="委托商:">-->
        <!--          <el-input v-model="form.consignor" size="mini" placeholder="请输入委托商"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label='品牌:'>
          <el-input v-model='form.brand' size='mini' placeholder='请输入品牌'></el-input>
        </el-form-item>
        <el-form-item label='型号:'>
          <el-input v-model='form.model' size='mini' placeholder='请输入型号'></el-input>
        </el-form-item>
        <el-form-item label='是否新能源:'>
          <el-select v-model='form.isNewEnergy' filterable size='mini' placeholder='全部'>
            <el-option label='全部' value=''></el-option>
            <el-option label='是' value='1'></el-option>
            <el-option label='否' value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='状态:'>
          <el-select v-model='form.status' filterable size='mini' placeholder='全部'>
            <el-option label='全部' value=''></el-option>
            <el-option label='启用中' value='1'></el-option>
            <el-option label='禁用中' value='2'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div style='display: flex;justify-content: flex-end;'>
          <span class='el-icon-download el-icon--right' @click='download'>模板下载</span>
          <span style='cursor: pointer'>
              <el-upload
                ref='upload'
                class='upload-demo'
                :action='uploadUrl'
                :auto-upload='true'
                :show-file-list='false'
                :data='uploadData'
                :on-success='planOnSuccess'
                :before-upload='beforeUpload'
              >
                <i class='el-icon-upload el-icon--right'>批量导入</i>
              </el-upload>
          </span>
          <span @click='exportClick' class='el-icon--right'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50' type='index'
                           :index='tableIndexMethod' />
          <!--          <el-table-column prop="customerName" label="委托商" align="center"/>-->
          <el-table-column prop='brandName' label='品牌名称' align='center' />
          <el-table-column prop='model' label='型号名称' align='center' />
          <el-table-column prop='config' label='配置' align='center' />
          <el-table-column prop='weight' label='重量' align='center' />
          <el-table-column prop='volume' label='长x宽x高' align='center'>
            <template slot-scope='scope'>
              {{ scope.row |changKuFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='isNewEnergy' label='是否新能源' align='center'>
            <template slot-scope='scope'>
              <span v-if="scope.row.isNewEnergy=='0'">否</span>
              <span v-else-if="scope.row.isNewEnergy=='1'">是</span>
            </template>
          </el-table-column>

          <el-table-column prop='state' label='状态' align='center'>
            <template slot-scope='scope'>
              <span>{{ scope.row.status |statusFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label='操作' width='280' align='center'>
            <template slot-scope='scope'>

              <el-button size='mini' class='searchBtn' type='primary'
                         @click='detailClick(scope.row)'>详情
              </el-button>
              <el-button size='mini' type='danger' @click='DisableClick(scope.row.id, scope.row)'
                         v-if='scope.row.state ==1 '>禁用
              </el-button>
              <el-button size='mini' type='primary' @click='EnableClick(scope.row.id, scope.row)'
                         v-if='scope.row.state ==2 '>启用
              </el-button>
              <el-button size='mini' class='yellow-bg' @click='modifyClick(scope.row)'>修改
              </el-button>
              <el-button size='mini' type='info' @click='deleteClick(scope.row)'
                         v-if='scope.row.state ==2 '>删除
              </el-button>


            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>

    <el-dialog :title="modifyflag ? '修改委托车车型':'添加委托车车型'" :visible.sync='addflag' width='623px'
               center @close='dialogClose'>
      <div class='add'>
        <el-form :model='addform' label-width='100px' :rules='rules' ref='ruleForm'
                 class='demo-ruleForm'>
          <!--          <el-form-item label="委托商名称：" prop="customerName" label-width="110px">-->
          <!--            <el-input v-model="addform.customerName"  size="mini"  placeholder="请选择委托商名称" >-->
          <!--            </el-input>-->
          <!--          </el-form-item>-->
          <!--          <hr color="#F0F0F2"/>-->
          <el-form-item label='品牌：' prop='brandId'>
            <el-select size='mini' filterable v-model='addform.brandId' placeholder='请选择品牌'>
              <el-option v-for='(item,index) in BrandList' :value='item.id' :label='item.brand'
                         :key='`${index}aa`'></el-option>
            </el-select>
          </el-form-item>
          <hr color='#F0F0F2' />
          <el-form-item label='型号：' prop='model'>
            <el-input
              :style="'width:100%'"
              v-model='addform.model'
              placeholder='请输入型号'
              autocomplete='off'
              size='small'
            />
          </el-form-item>
          <hr color='#F0F0F2' />
          <el-form-item label='配置：' prop='config'>
            <el-input
              :style="'width:100%'"
              v-model='addform.config'
              placeholder='请输入配置'
              autocomplete='off'
              size='small'
            />
          </el-form-item>
          <hr color='#F0F0F2' />
          <el-form-item label='重量：' prop='weight'>
            <el-input
              :style="'width:100%'"
              v-model='addform.weight'
              placeholder='请输入重量'
              autocomplete='off'
              size='small'
            />
          </el-form-item>
          <hr color='#F0F0F2' />
          <el-form-item label='长宽高：' prop='length'>
            <el-input
              style='width: 50px'
              v-model='addform.length'
              placeholder='长'
              autocomplete='off'
              size='small'
            />
            x
            <el-input
              style='width: 50px'
              v-model='addform.width'
              placeholder='宽'
              autocomplete='off'
              size='small'
            />
            x
            <el-input
              style='width: 50px'
              v-model='addform.height'
              placeholder='高'
              autocomplete='off'
              size='small'
            />
          </el-form-item>
          <hr color='#F0F0F2' />
          <el-form-item label='新能源：' prop='isNewEnergy'>
            <el-radio v-model='addform.isNewEnergy' label='0'>否</el-radio>
            <el-radio v-model='addform.isNewEnergy' label='1'>是</el-radio>
          </el-form-item>
        </el-form>
        <hr color='#F0F0F2' />
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick()'>确认
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </div>


    </el-dialog>

    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='623px' center
               @close='dialogClose'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.status |statusFormat }}</p>
          </div>
          <el-form :model='detailData' label-position='left'>
            <div class='baseInfoContent'>

              <!-- <el-form-item label="委托商:">
                <span>{{detailData.customerName}}</span>
              </el-form-item> -->
              <el-form-item label='品牌名称:'>
                <span>{{ detailData.brandName }}</span>
              </el-form-item>
              <el-form-item label='型号名称:'>
                <span>{{ detailData.model }}</span>
              </el-form-item>
              <el-form-item label='配置:'>
                <span>{{ detailData.config }}</span>
              </el-form-item>
              <el-form-item label='重量:'>
                <span>{{ detailData.weight }}</span>
              </el-form-item>
              <el-form-item label='长宽高:'>
                <span>{{ detailData | changKuFormat }}</span>
              </el-form-item>
              <el-form-item label='是否新能源:'>
                <span v-if="detailData.isNewEnergy=='0'">否</span>
                <span v-if="detailData.isNewEnergy=='1'">是</span>
              </el-form-item>
              <el-form-item label='创建时间:'>
                <span>{{ detailData.createTime |createTimeFormat }}</span>
              </el-form-item>
            </div>

          </el-form>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>操作记录</span>
            </div>
            <!--            :icon="activity.icon"-->
            <div class='baseInfoContent'>
              <el-table :data='operationData' border
                        :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}">
                <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                <el-table-column prop='operateType' label='操作类型' align='center' />
                <el-table-column prop='operationName' label='操作人' align='center' />
                <el-table-column prop='remark' label='备注' align='center' />
              </el-table>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>
  import { contractTypeDelete, contractTypeIsEnable } from '@/service/contract';
  import {
    brandGetCarBrandList,
    modelAddCarBrand,
    modelCarBrandDetail,
    modelCarModelList,
    modelUpdateCarBrand,
  } from '@/service/basicfile';
  import { formatTime, getSessionStore } from '@/config/mUtils';
  import batchImport from '@/components/batchImport';
  import { baseUrl } from '@/config/env';
  import { getImport, getImportUrl } from '@/service/getIP';

  export default {
    components: {
      batchImport,
    },
    data() {
      return {
        importLoading: false,
        form: {
          consignor: '',
          brand: '',
          model: '',
          isNewEnergy: '',
          status: '',
          page: 1,
          rows: 10,

        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        addform: {
          customerName: '',
          brandId: '',
          model: '',
          config: '',
          weight: '',
          length: '',
          width: '',
          height: '',
          isNewEnergy: '',
        },
        DialogVisible: false,
        addLoad: false,
        addflag: false,
        modifyflag: false,
        detailDialogVisible: false,
        detailData: {
          customerName: '',
          brand: '',
          model: '',
          config: '',
          weight: '',
          volume: '',
          creatTime: '',
          status: '启用',
        },
        operationData: [],
        uploadUrl: '',//导入地址
        uploadData: {
          mFile: '',//文件名
        },
        BrandList: [],
        modifyId: '',
        rules: {
          isNewEnergy: [{
            required: true,
            message: '请选择是否新能源',
            trigger: 'blur',
          }],
          customerName: [
            {
              required: true,
              message: '请选择委托商名称',
              trigger: 'change',
            },
          ],
          brandId: [
            {
              required: true,
              message: '请选择品牌',
              trigger: 'blur',
            },
          ],
          model: [
            {
              required: true,
              message: '请输入型号',
              trigger: 'blur',
            },
          ],
          config: [
            {
              required: true,
              message: '请输入配置',
              trigger: 'blur',
            },
          ],
          weight: [
            {
              required: true,
              message: '请输入重量',
              trigger: 'blur',
            },
          ],
          length: [
            {
              required: true,
              message: '请输入长宽高',
              trigger: 'blur',
            },
          ],
        },
      };

    },
    filters: {
      createTimeFormat: function(value) {
        console.log(value);
        if (value) {
          return formatTime(value, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }

      },
      statusFormat(val) {
        let text = '';
        switch (val) {
          case 1:
            text = '启用中';
            break;
          case 1:
            text = '禁用中';
            break;

        }
        return text;
      },
      changKuFormat(row) {
        return `${row.length}x${row.width}x${row.height}`;

      },
    },
    created() {
      this.$nextTick(() => {
        this._modelCarModelList();

      });
      // let token = getSessionStore('token')
      // this.uploadUrl  = baseUrl + `/platform/addExecInfo/readInfo?access_token=${token}`
      this.uploadUrl = getImportUrl('/car/model/modelBatchImport');
    },
    methods: {
      async _brandGetCarBrandList() {
        let res = await brandGetCarBrandList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.BrandList = res.data;
      },
      async _modelCarModelList() {
        this.tableLoad = true;
        let res = await modelCarModelList({
          ...this.form,
          brandName: this.form.brand,
          model: this.form.model,
          status: this.form.status,
        });
        this.tableLoad = false;
        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.TableDatas = res.data.records;
        this.total = res.data.total;

      },
      searchBtn() {
        this.form.page = 1;
        this._modelCarModelList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;

      },
      addBtn() {
        this.modifyflag = false;
        this.addflag = true;
        this._brandGetCarBrandList();
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._modelCarModelList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._modelCarModelList();
      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      async detailClick(row) {
        this.detailDialogVisible = true;
        let res = await modelCarBrandDetail(row.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this.operationData = res.data.operateRecordList;

      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return  this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data
        // this._modelCarModelList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._modelCarModelList();
          },
        });
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      // importSuccess(data){
      //   console.log(data)
      //   this._modelCarModelList()
      // },
      //模板下载
      download() {
        window.location.href = '/file/车型导入模板.xlsx';
      },
      // 导出数据
      exportClick() {
        // const obj = `&brandName=${this.form.brand}&model=${this.form.model}&status=${this.form.status}&consignor=${this.consignor}&isNewEnergy=${this.form.isNewEnergy}`;
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/car/model/modelExport?access_token=${token}${obj}`;
        window.exportExcelGet('/platform/car/model/modelExport', `brandName=${this.form.brand}&model=${this.form.model}&status=${this.form.status}&consignor=${this.consignor}&isNewEnergy=${this.form.isNewEnergy}`)
      },
      deleteClick(row) {
        this.$confirm('确认要删除当前委托车型号吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await contractTypeDelete(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._modelCarModelList();
          })
          .catch(() => {
          });
      },
      EnableClick(id, row) {
        this.$confirm('确认要启用当前委托车型号吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await contractTypeIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);

            }
            await this._modelCarModelList();
            this.$message.success(res.message);

          })
          .catch(() => {
          });
      },
      DisableClick(id, row) {
        this.$confirm('确认要禁用当前委托车型号吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            // let res =await contractTypeIsEnable(id)
            // if (res.status!==0) {
            //   return  this.$message.error(res.message);
            // }
            // await this._modelCarModelList();
            // this.$message.success(res.message);


          })
          .catch(() => {
          });
      },
      async addClick(flag) {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.addLoad = true;
            if (this.modifyflag) {
              //修改
              let res = await modelUpdateCarBrand(this.addform);
              this.addLoad = false;
              if (res.status !== 0) {
                return this.$message.error(res.message);
              }
              this.$message.success(res.message);
            } else {
              //添加
              let res = await modelAddCarBrand(this.addform);
              this.addLoad = false;
              if (res.status !== 0) {
                return this.$message.error(res.message);
              }
              this.$message.success(res.message);
            }
            await this._modelCarModelList();
            this.dialogClose();
          } else {
            console.log('error submit!!');
          }
        });

      },
      //清除数据
      clearData(flag) {
        if (flag === 1) {
          for (let addformKey in this.addform) {
            this.addform[addformKey] = '';
          }
        } else {
          for (let modifyformKey in this.modifyform) {
            this.modifyform[modifyformKey] = '';
          }
        }
      },
      dialogClose() {
        this.addflag = false;
        this.$refs.ruleForm.resetFields();
        for (const argumentsKey in this.addform) {
          this.addform[argumentsKey] = '';
        }
      },
      async modifyClick(row) {
        this.modifyflag = true;
        this.addflag = true;
        await this._brandGetCarBrandList();
        let res = await modelCarBrandDetail(row.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.addform = {
          customerName: '',
          ...res.data,
        };
        let isNewEnergy = res.data.isNewEnergy.toString();
        this.addform.isNewEnergy = isNewEnergy;

      },
    },
  };
</script>


<style lang='scss' scoped>
  .carModel-model {
    /*width:100%;*/
    //padding:20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    display: flex;
    flex-direction: column;

    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      ::v-deep {
        .el-form-item {
          margin-bottom: 0
        }

        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }
    }

    .content {
      .tableContainer {
        margin-bottom: 25px;
        margin-top: 10px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }
    }

    ::v-deep.add {
      padding: 26px 40px;

      .el-input {
        width: 280px;
      }

      .el-input__inner {
        border: none;
      }

      .el-form-item__label {
        /*color: #060606;*/
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 0px;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;

      button {
        margin: 0 15px;
      }
    }

    ::v-deep .detail {

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;


          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
              font-weight: 700;
            }
          }

        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

  }

  ::v-deep {
    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
      color: rgb(51, 136, 255);
      margin-left: 10px;
    }

    span.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
      cursor: pointer;
      font-size: 16px;
      color: rgb(51, 136, 255);
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
    }


  }
</style>
